import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import {
  FileInput,
  form,
  Form as AppForm
} from "MODULES/shared/components/Forms";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { importLineItems } from "MODULES/RepairOrders/actions";
import { Warning } from "MODULES/shared/components";

const formName = "ImportExpectdComponents";

function ImportExpectedComponentsForm(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Warning>
            Please label column header fields: part_number, cond, tag_date,
            original_evaluation, parts_cost, labor_cost, transfer_cost. *fields
            are mandatory. Acceptable condition codes: ne, oh, sv, sv_tooling,
            bt, ar, br. If cond. = ar, br, or sv_tooling then tag_date can
            remain blank. Cost field can entered as 0. Import file must be in
            .csv format.
          </Warning>
        </FormRow>
        <FormRow>
          <Col md={8}>
            <Field
              name="file"
              component={FileInput}
              label="Upload Attachment"
              required
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={8} mdOffset={2}>
            <a
              href="https://info-trader-assets.s3.us-east-2.amazonaws.com/public/InfoTrader_Import_Template_v4.csv"
              target="_blank"
              rel="noopener noreferrer"
            >
              Template
            </a>
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(importLineItems(data))
}))(
  form({
    form: formName
  })(ImportExpectedComponentsForm)
);



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/ImportExpectedComponents/ImportExpectedComponentsForm.jsx